import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';

export const RowIcon = ({ iconKey, icon, color, toolTip }) => {
  return (
    <Tooltip title={toolTip}>
      <FontAwesomeIcon icon={icon} color={color} />
    </Tooltip>
  );
};
